import { inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { MetaService } from './meta.service';

function initialiseMeta(metaService: MetaService) {
  return () => metaService.watchRouting();
}

export function provideMetaInitializer() {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      const initializerFn = initialiseMeta(inject(MetaService));
      return initializerFn();
    }),
  ]);
}
